import React from 'react'
import PropTypes from 'prop-types'
import { sizes, useTheme } from '@qflow/theme'

export function ExternalLink({ size = sizes.LARGER, colour, ...props }) {
  const theme = useTheme()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      style={{ width: size, height: size }}
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        stroke={colour || theme.secondary.fg}
        d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
      />
    </svg>
  )
}

ExternalLink.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
